module.exports = {
      id: "islide-more-6-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#islide-more-6-usage",
      toString: function () {
        return this.url;
      }
    }